/**
 * TermsOfUsePage
 *
 * Static public page displaying the Terms of Use.
 * Accessible without authentication.
 */
import { useLocale } from '@/presentation/contexts/LocaleContext';
import { LegalDocumentPage } from './LegalDocumentPage';
import termsOfUseHtml from './content/termsOfUse.html?raw';

export const TermsOfUsePage = () => {
  const { l10n } = useLocale();
  return <LegalDocumentPage qaId="legal-terms" title={l10n.legal.termsOfUse} htmlContent={termsOfUseHtml} />;
};
